import Message from "./Message"
import Header from "./Header"
import {Col, Row} from "react-bootstrap"
import SideBar from "./Navigation/SideBar"
import Footer from "./Footer"
import React, {Fragment, useEffect, useRef} from "react"
import {useAppDispatch, useAppSelector} from "../redux/Hooks"
import {getCookie} from "../utils/cookies"
import {getUserByToken} from "../api/UserAPI"
import {useNavigate} from "react-router-dom"

export default function Layout({...props}) {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const showMessage = useAppSelector((state) => state.message.showMessage)
    const token = getCookie("accessToken")
    const mounted = useRef()
    const user = useAppSelector((state) => state.app.user)

    useEffect(() => {
        !mounted.current && componentDidMount()
    })

    const componentDidMount = () => {
        token && dispatch(getUserByToken({token: token})).then(() => {
            // @ts-ignore
            mounted.current = true
        })
    }

    useEffect(() => {
        const noAuthPages = ["/mentions-legales", "/conditions-generales-d-utilisation", "/s-identifier", "/nouveau-compte/set-password", "/set-password"]
        if ((!token || (null === user.id && mounted.current)) && !noAuthPages.includes(window.location.pathname)) {
            return navigate("/s-identifier")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.id, mounted.current])

    return (
        <Fragment>
            {
                showMessage &&
                <Message/>
            }
            <Header/>
            <div className="wrap">
                <Row className="row-0 h-100">
                    {user.id &&
                        <Col xs="auto">
                            <SideBar/>
                        </Col>
                    }
                    <Col>
                        <div className="main">
                            <Row className="row-0 h-100 flex-column">
                                <Col>{props.children}</Col>
                                <Col xs="auto" className="mt-8">
                                    <Footer/>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>
        </Fragment>
    )
}
